module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "submitted.199fd7a6.png";